import { Component, Inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { Observable } from "rxjs";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { CommonService } from "../../services/common.service";

@Component({
  selector: "app-recent-reviews",
  templateUrl: "./recent-reviews.component.html",
  styleUrls: ["./recent-reviews.component.scss"],
})
export class RecentReviewsComponent implements OnInit {
  @Input() isTotalReviewAvailable: boolean;
  public loading = false;

  private BASE_URL = GlobalVariable;
  outletId: string;
  latestReviews:any = [];
  sortOption: string = "";

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private httpService: DataService,
    private router: Router,
    private commonservice: CommonService
  ) {}

  getReviews() {
    let res: Response;
    const page = 1;
    const size = 3;
    const sort_order = "RECENT";
    this.httpService
      .commonServiceFunction(
        this.BASE_URL.REVIEW_FEED_API_V2(this.outletId),
        page,
        size,
        sort_order
      )
      .subscribe((data: Response) => {
        res = data;
        this.latestReviews = res.data["reviews"];
        this.loading = false;
      });
  }
  ngOnInit() {
    this.loading = true;
    this.outletId = this.storage.get("outlet_id");
    this.getReviews();
  }

  reviews() {
    this.router.navigate(["/reviews"]);
  }
}
